import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import { ReadData } from "../../../../providers/Patient.Provider";
import auth from "../../../../providers/Auth.Provider";
import RoomSearchList from "./RoomSearchList";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { LIST, START_SEARCH } from "../../../../queries/room-search.query";
import LoadingSpinner from "../../../../partials/loading";
import AlertMessage from "../../../../partials/alertMessage";
import NewRoomSearch from "./NewRoomSearch.jsx";
import RoomSearchDetail from "./RoomSearchDetail";

function RoomSearch() {
    // local state
    const [newSearch, setNewSearch] = useState(false);
    const [search, setSearch] = useState(null);

    // local data
    const patient = ReadData();
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { site } = GetToken() && GetAuthenticatedStaff();
    // query
    const { loading, error, data } = useQuery(LIST, {
        variables: {
            id: patient.lastAdmission,
            site: site && site.id
        }
    });

    // New
    const [PostFunc, { loading: cLoading, error: cError, data: cData }] = useMutation(START_SEARCH, {
        update(caches, { data: { NewRoomSearch } }) {
            const { GetRoomSearches } = caches.readQuery({
                query: LIST,
                variables: {
                    site: site && site.id,
                    id: patient.lastAdmission
                }
            });
            GetRoomSearches.docs.unshift(NewRoomSearch.doc);
            caches.writeQuery({
                query: LIST,
                variables: {
                    site: site && site.id,
                    id: patient.lastAdmission
                },
                data: { GetRoomSearches }
            });
        }
    });

    if (patient && !patient.lastAdmission)
        return (
            <div className="text-center">
                <h2 className="text-pink">Feature can only be used for in-patient only!</h2>
            </div>
        );

    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    return (
        <>
            <Helmet>
                <title>Patient Room Search | {appName}</title>
            </Helmet>
            <div className="row justify-content-center">
                {newSearch && !search && (
                    <div className="col md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewSearch(false);
                                            setSearch(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    New Room Search
                                </header>
                            </div>
                            <div className="card-body m-b-20" style={{ minHeight: "420px" }}>
                                <LoadingSpinner loading={cLoading} />
                                <AlertMessage message={cError && cError.message} failed={true} />
                                <AlertMessage message={cData && cData.NewRoomSearch.message} />

                                <NewRoomSearch
                                    searchMembers={data && data.GetStaffList.docs}
                                    onCancel={() => {
                                        setNewSearch(false);
                                        setSearch(null);
                                        scrollTop();
                                    }}
                                    onSubmit={async item => {
                                        await PostFunc({
                                            variables: {
                                                model: {
                                                    ...item,
                                                    admission: patient.lastAdmission
                                                },
                                                admission: patient.lastAdmission
                                            }
                                        });
                                        setTimeout(() => {
                                            setNewSearch(false);
                                            setSearch(null);
                                            scrollTop();
                                        }, 500);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {!newSearch && !search && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>Room Search List</header>
                                <div className="float-right mt-2 mr-2">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setNewSearch(true);
                                            setSearch(null);
                                            scrollTop();
                                        }}
                                        className="mdl-button fade-in mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle"
                                    >
                                        <i className="material-icons text-primary">add</i> New Room Search
                                    </button>
                                </div>
                            </div>
                            <div className="card-body m-b-20" style={{ minHeight: "420px" }}>
                                <LoadingSpinner loading={loading} />
                                <AlertMessage message={error && error.message} failed={true} />
                                {!loading && (
                                    <RoomSearchList
                                        className="fade-in"
                                        items={data && data.GetRoomSearches.docs}
                                        onView={item => {
                                            setSearch(item);
                                            scrollTop();
                                            setNewSearch();
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {!newSearch && search && (
                    <div className="col md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewSearch(false);
                                            setSearch(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Search Detail
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                <RoomSearchDetail item={search} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default RoomSearch;
